<template>
  <div class="container bg-gray-100 pb-4 pt-5 p-4 w-full">
    <!-- <div v-if="!isModalOpen" class="container bg-white rounded-lg mt-3 box-shadow flex-col"> -->
    <div class="flex justify-center">
      <loading
        :height="15"
        color="#fff"
        backgroundColor="#494343cc"
        :active="isLoading"
        loader="dots"
        :can-cancel="true"
        :is-full-page="true"
      />
    </div>
    <router-link type="button" class="hover:underline block text-left" to="/digital-sales-report">
      <svg class="h-8 w-8 fill-current text-blue-900" xmlns="http://www.w3.org/2000/svg"
        viewBox="274.835 394.86 54.965 55.15">
        <defs />
        <path
          d="M302.4 395.823c14.752.013 26.694 12.004 26.695 26.805.001 14.592-12.041 26.517-26.753 26.495-14.737-.023-26.754-11.98-26.684-26.551.072-14.873 11.958-26.763 26.742-26.749zm.342 32.534h2.447c3.522 0 7.044.033 10.565-.013 2.327-.03 3.413-1.138 3.479-3.442.039-1.364.033-2.731.003-4.096-.057-2.537-.978-3.536-3.514-3.605-2.801-.076-5.605-.022-8.408-.024-1.471-.001-2.942 0-4.571 0 0-1.899.247-3.457-.079-4.885-.254-1.114-1.01-2.527-1.934-2.949-.783-.357-2.422.2-3.171.899-3.518 3.284-6.88 6.737-10.254 10.171-1.618 1.646-1.652 3.053-.056 4.689 3.413 3.497 6.829 6.997 10.403 10.326.73.68 2.361 1.107 3.203.755.868-.363 1.601-1.754 1.812-2.811.3-1.513.075-3.132.075-5.015z" />
      </svg>
    </router-link>
    <div v-if=true class="container bg-white rounded-lg mt-3 box-shadow flex-col"></div>
    <p class="w-full text-center text-2xl mb-2">Coberturas</p>
    <p class="w-full text-center text-xs text-gray-600">
      Datos de usuario y coberturas contratadas actualmente:
    </p>
    <!-- <p class="bold text-red-600" v-if="modulesAvailableTitular <= 0"> -->
    <!-- <p class="bold text-red-600" v-if="false"></p>
    Titular alcanzó el máximo de coberturas contratadas. -->
    <h3 class="text-left text-lg">
      {{ digitalInsuranceSale.member.nombre + " " + digitalInsuranceSale.member.apellido_paterno + " " +
        digitalInsuranceSale.member.apellido_materno }}
    </h3>
    <h2></h2>
    <!-- <div v-if="modulesAvailableTitular === maximunCoveragesTitular">
        Sin coberturas
      </div> -->
    <div>
      <div class="flex justify-around text-base mb-1 flex-wrap">

        <div class="seccion font-bold">
          {{ digitalInsuranceSale.member.lm_section.nombre }}
        </div>
        <div class="modulo">
          Tipo de pago:
          <span class="font-bold"> {{ digitalInsuranceSale.tipo_de_pago }} </span>
        </div>
        <div class="modulo">
          Fecha de venta:
          <span class="font-bold"> {{ digitalInsuranceSale.fecha_de_venta }} </span>
        </div>
        <div class="modulos_disponibles">
          Estatus:
          <span class="font-bold"> {{ digitalInsuranceSale.status }} </span>
        </div>
      </div>
      <div class="card" v-if="digitalInsuranceSale.headline_digital_sales_coverages.length > 0">
        <div class="modulo">
          Modulos:
          <span class="font-bold"> {{ getTotalModulesCoverage(digitalInsuranceSale.headline_digital_sales_coverages) }} </span>
        </div>
        <table  class="table-auto">
          <thead>
            <tr>
              <th class="col pt-2">
                <h3 class="text-left text-sm">Coberturas Contratadas</h3>
              </th>
              <th class="col">
                <h3 class="text-center text-sm">Módulos</h3>
              </th>
              <th class="col">
                <h3 class="text-center text-sm">Plan</h3>
              </th>
              <th class="col">
                <h3 class="text-sm">Suma Asegurada Actual</h3>
              </th>

              <th class="col">
                <h3 class="text-sm">Pago Quincenal</h3>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="coverage in digitalInsuranceSale.headline_digital_sales_coverages" :key="coverage.id">
              <td class="col">
                <p class="text-left m-0 text-xs">
                  {{ coverage.type_coverage.cobertura }}
                </p>
              </td>
              <td class="col">
                <p class="text-center m-0 text-xs">
                  {{ coverage.modulos }}
                </p>
              </td>
              <td class="col">
                <p class="text-center m-0 text-xs">
                  {{ coverage.plan }}
                </p>
              </td>
              <td class="col">
                <p class="text-center m-0 text-xs">
                  {{ $filters.toCurrency(coverage.suma_asegurada) }}
                </p>
              </td>
              <td class="col">
                <p class="text-center m-0 text-xs">
                  {{ $filters.toCurrency(coverage.prima_quincenal) }}
                </p>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th style="padding-top: 60px;"></th>
              <th></th>
              <th></th>
              <th></th>
              <th>
                <h3 class="text-sm m-0 text-black">
                  <span class="w-2 text-xl border-t-2 text-green-500 pl-6 pr-6 pt-2 border-grey-600">{{
                    $filters.toCurrency(getTotalAmountCoverage(digitalInsuranceSale.headline_digital_sales_coverages))
                  }}</span>
                </h3>
              </th>
            </tr>
          </tfoot>
        </table>

        <div class="w-full flex items-center justify-end sticky mt-3">
          <!-- <h3 class="text-sm m-0 text-left w-1/2 text-black">Módulos Contratados <span class="w-2  text-green-500 ml-2 pl-6 pr-6 pt-2 border-grey-600">{{totalAmountModules}}</span> </h3> -->
          <!-- <div @click="hideCoverage" class="square border-2 border-orange-400 cursor-pointer">

                <mdicon v-if="showCoberturas" class="text-orange-400" name="chevron-up"/>
                <mdicon v-else class="text-orange-400" name="chevron-down"/>
              </div> -->
        </div>
      </div>
      <!-- aqui beneficiarios -->
      <div class="card" v-if="digitalInsuranceSale.beneficiaries_digital_sale_insurance.length > 0">
        <div class="modulo">
          <span class="font-bold"> Beneficiarios </span>
        </div>
        <table  class="table-auto">
          <thead>
            <tr>
              <th class="col pt-2">
                <h3 class="text-left text-sm">Nombre</h3>
              </th>
              <th class="col">
                <h3 class="text-center text-sm">Parentesco</h3>
              </th>
              <th class="col">
                <h3 class="text-center text-sm">Porcentaje</h3>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="beneficiary in digitalInsuranceSale.beneficiaries_digital_sale_insurance" :key="beneficiary.id">
              <td class="col">
                <p class="text-left m-0 text-xs">
                  {{ beneficiary.nombres + " " + beneficiary.apellido_paterno + " " + beneficiary.apellido_materno }}
                </p>
              </td>
              <td class="col">
                <p class="text-center m-0 text-xs">
                  {{ beneficiary.kinship.parentesco }}
                </p>
              </td>
              <td class="col">
                <p class="text-center m-0 text-xs">
                  {{ beneficiary.porcentaje }}%
                </p>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th style="padding-top: 60px;"></th>
              <th></th>
              <th>
                <h3 class="text-sm m-0 text-black">
                  <span class="w-2 text-xl border-t-2 text-green-500 pl-6 pr-6 pt-2 border-grey-600">{{
                    getTotalPorcentageBeneficiaries(digitalInsuranceSale.beneficiaries_digital_sale_insurance)
                  }}%</span>
                </h3>
              </th>
            </tr>
          </tfoot>
        </table>

        <div class="w-full flex items-center justify-end sticky mt-3">
          <!-- <h3 class="text-sm m-0 text-left w-1/2 text-black">Módulos Contratados <span class="w-2  text-green-500 ml-2 pl-6 pr-6 pt-2 border-grey-600">{{totalAmountModules}}</span> </h3> -->
          <!-- <div @click="hideCoverage" class="square border-2 border-orange-400 cursor-pointer">

                <mdicon v-if="showCoberturas" class="text-orange-400" name="chevron-up"/>
                <mdicon v-else class="text-orange-400" name="chevron-down"/>
              </div> -->
        </div>
      </div>
    </div>
    <div v-if="digitalInsuranceSale.additional_digital_sales.length > 0" id="carouselExampleCaptions"
      class="card p-2 mt-3 carousel slide relative" data-bs-ride="carousel">
      <div>
        <h3 class="text-left text-lg">
          Dependientes adicionales
        </h3>

        <div class="carousel-inner relative w-full overflow-hidden">
          <button
            class="carousel-control-prev absolute top-0 bottom-0 flex items-center justify-start p-0 text-center border-0 hover:outline-none hover:no-underline focus:outline-none focus:no-underline left-0"
            type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
            <span class="text-black inline-block bg-no-repeat p-2 rounded-full bg-stone-900" aria-hidden="true">
              <mdicon name="chevron-left" />
            </span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button
            class="carousel-control-next absolute top-0 bottom-0 flex items-center justify-end p-0 text-center border-0 hover:outline-none hover:no-underline focus:outline-none focus:no-underline right-0"
            type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
            <span class="text-black inline-block bg-no-repeat p-2 rounded-full bg-stone-900" aria-hidden="true">
              <mdicon name="chevron-right" />
            </span>
            <span class="visually-hidden">Next</span>
          </button>
          <div class="carousel-item relative float-left w-full"
            v-for="(dependentCoverages, index) in digitalInsuranceSale.additional_digital_sales" :key="dependentCoverages"
            :class="{ active: index == 0 }">
            <div class="flex justify-center">
              <div class="card w-full flex-row flex-wrap">
                <div class="flex justify-around w-full">
                  <!-- <div class="text-left text-lg">
                    Asegurado Adicional:
                    <span class="font-bold">{{ dependentCoverages.nombres }} {{ dependentCoverages.apellido_paterno }} {{ dependentCoverages.apellido_materno }}</span>
                  </div>
                  <div class="text-left text-lg">
                    Fecha de nacimiento:
                    <span class="font-bold"> {{ dependentCoverages.fecha_de_nacimiento }} </span>
                  </div>
                  <div class="text-left text-lg">
                    Parentesco:
                    <span class="font-bold"> {{ dependentCoverages.parentesco }} </span>
                  </div> -->
                  <div class="modulo">
                    Asegurado Adicional:
                    <span class="font-bold"> {{ dependentCoverages.nombres }} {{ dependentCoverages.apellido_paterno }} {{ dependentCoverages.apellido_materno }} </span>
                  </div>
                  <div class="modulo">
                    Fecha de nacimiento:
                    <span class="font-bold"> {{ dependentCoverages.fecha_de_nacimiento }} </span>
                  </div>
                  <div class="modulos_disponibles">
                    Parentesco:
                    <span class="font-bold"> {{ dependentCoverages.parentesco }} </span>
                  </div>
                </div>
                
                <table class="table-auto w-full">
                  <thead>
                    <tr>
                      <th class="pt-2">
                        <h3 class="text-left text-sm">
                          Coberturas Contratadas
                        </h3>
                      </th>

                      <th class="col">
                        <h3 class="text-center text-sm">Módulos</h3>
                      </th>
                      <th class="col">
                        <h3 class="text-center text-sm">Plan</h3>
                      </th>
                      <th>
                        <h3 class="text-sm">Suma Asegurada Actual</h3>
                      </th>
                      <th>
                        <h3 class="text-sm">Pago Quincenal</h3>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="coverages in dependentCoverages.additional_digital_sales_coverages" :key="coverages">
                      <td class="col">
                        <p class="text-left m-0 text-xs">
                          {{ coverages.type_coverage.cobertura }}
                        </p>
                      </td>
                      <td class="col">
                        <p class=" text-center m-0 text-xs">
                          {{ coverages.modulos }}
                        </p>
                      </td>
                      <td class="col">
                        <p class=" text-center m-0 text-xs">
                          {{ coverages.plan }}
                        </p>
                      </td>
                      <td class="col">
                        <p class="text-center m-0 text-xs">
                          {{ $filters.toCurrency(coverages.suma_asegurada) }}
                        </p>
                      </td>
                      <td class="col">
                        <p class="text-center m-0 text-xs">
                          {{ $filters.toCurrency(coverages.prima_quincenal) }}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th style="padding-top: 60px;"></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th>
                        <h3 class="text-sm m-0 text-black">
                          <span class="text-xl w-2 border-t-2 text-green-500 pl-6 pr-6 pt-2 border-grey-600">{{
                            $filters.toCurrency(getTotalAmountCoverage(dependentCoverages.additional_digital_sales_coverages))
                          }}</span>
                        </h3>
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="carousel-indicators controls static mx-auto w-full flex justify-center">
          <button v-for="(dependentCoverages, index) in digitalInsuranceSale.additional_digital_sales"
            :key="dependentCoverages" :class="{ active: index == 0 }" data-bs-target="#carouselExampleCaptions"
            :data-bs-slide-to="index" class="border-0 ball h-5 w-5 active:bg-blue-dark bg-orange-500 rounded-full m-2 "
            aria-current="true"></button>
        </div>
        <div class="w-full">
          <div class="table px-4">
            <div class="flex flex-column items-center md:table-row">
              <div class="table-cell">
                <h3 class="text-lg text-left border-none">
                  Total Coberturas
                </h3>
              </div>
              <div class="table-cell"></div>
              <div class="table-cell after:border-white">
                <div class="border-none">
                  <h4 class="text-sm text-black">
                    Total de Módulos Adicionales
                  </h4>
                  <span class="w-2 text-green-500 text-lg">
                    {{ totalModulesDependents }}
                  </span>
                </div>
              </div>
              <div class="table-cell">
                <div class="border-none">
                  <h4 class="text-sm text-black">Pago Quincenal</h4>
                  <span class="w-2 text-green-500 text-lg ">
                    {{$filters.toCurrency(totalAmountDependents)}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full flex items-center justify-end sticky mt-3">

    </div>
    <div class="card">
      <table v-if="digitalInsuranceSale.documents_digital_sales.length > 0" class="table-auto">
        <thead>
            <tr>
              <th class="col pt-2">
                <h3 class="text-lg text-left border-none">Archivos</h3>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="document_digital in digitalInsuranceSale.documents_digital_sales" :key="document_digital.id">
              <td class="col">
                <p class="text-left m-0 text-xs text-blue-700">
                  <a :href=document_digital.url download>{{document_digital.tipo_documento}}</a>
                </p>
              </td>
            </tr>
          </tbody>
      </table>
    </div>
    <div v-if="digitalInsuranceSale.status == 'PENDIENTE'" class="w-full p-2  mt-5 mb-2">
      <span class="p-2  mt-5 mb-2">
        <button
          @click="change_to_inactive"
          class=" justify-center  md:w-1/6 lg:w-1/6 xl:w-1/6 bg-orange-600 hover:bg-orange-700 text-xl text-white font-bold py-2 px-4 rounded"
        >
          Rechazar
        </button>
      </span> 
      <span>
        <button
          @click="change_to_active"
          class=" justify-center  md:w-1/6 lg:w-1/6 xl:w-1/6 bg-orange-600 hover:bg-orange-700 text-xl text-white font-bold py-2 px-4 rounded"
        >
          Aceptar
        </button>
      </span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
// import moment from "moment";
// import emptyPolicy from "../assets/EmptyPolicy.json";
import Loading from "vue-loading-overlay";
export default {
  name: "DigitalSale",
  components: {
    Loading
  },
  data() {
    return {
      api_lineamagisterialproducts: process.env.VUE_APP_APILINEAMAGISTERIALPRODUCTS,
      digital_insurance_id: null,
      showTableDigitalInsurance: true,
      digitalInsuranceSale: null,
      urlParams: null,
      errorSection: false,
      ccAPI: process.env.VUE_APP_CCAPI,
      token_auth: null,
      isLoading: false,
      totalModulesDependents: 0,
      totalAmountDependents: 0,
      totalModulesIncumbent: 0,
    }
  },
  async created() {
    this.isLoading = true
    await this.getTokenAuth();
    await this.getDigitalSale();
    this.isLoading = false
  },
  methods: {
    async getTokenAuth() {
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      let data = {
        user: {
          email: "aplm@gcabsa.com.mx",
          password: "cabsa2022",
        },
      };

      await axios.post(this.ccAPI + "/fas/login", data, config).then((dataa) => {
        this.token_auth = dataa.data.token_auth;
      });
    },
    async getDigitalSale() {
      await axios.get(
        `${this.ccAPI}digital_sale_personal_accidents/get`,
        { params: { insurance_id: this.$route.params.digital_insurance_id, token_auth: this.token_auth } }
      )
        .then((data) => {
          this.digitalInsuranceSale = data.data.response.data
          this.getTotalModuleDependent(this.digitalInsuranceSale.additional_digital_sales);
        })
    },
    async updateDigitalSale(){
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      let data = {
        token_auth: this.token_auth,
        id: this.digitalInsuranceSale.id,
        lm_insurance_digital_sale: {
          status: "BAJA"
        },
      };

      await axios.post(this.ccAPI + "/lm/digital_sale_personal_accidents/update", data, config).then((api_reponse) => {
          if (api_reponse.status == 200 && api_reponse.data.response.message == "Actualización exitosa") {
            this.digitalInsuranceSale = api_reponse.data.response.data;
            this.getTotalModuleDependent(this.digitalInsuranceSale.additional_digital_sales);
            this.swal_fire("Dado de baja correctamente!",api_reponse.data.response.message,"");
            return this.$router.push({ name: "digital-sales-report" });
          }else{
            this.swal_fire("warning","Cuidado!!",api_reponse.data.response.message);
          }
      });
    },
    async create_personal_accident_from_digital_sale(){
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      let data = {
        token_auth: this.token_auth,
        accidents_and_illness: {
          id: this.digitalInsuranceSale.id
        },
      };

      await axios.post(this.ccAPI + "/lm/accidents_and_illnesses/register", data, config).then((api_reponse) => {
          if (api_reponse.status == 200 && api_reponse.data.response.message == "Seguro personal se ha creado exitosamente!!") {
            this.digitalInsuranceSale = api_reponse.data.response.result;
            this.getTotalModuleDependent(this.digitalInsuranceSale.additional_digital_sales);
            this.swal_fire("Aceptado correctamente!",api_reponse.data.response.message,"");
            return this.$router.push({ name: "digital-sales-report" });
          }else{
            this.swal_fire("warning","Cuidado!!",api_reponse.data.response.message);
          }
      });
    },
    getTotalAmountCoverage(array) {
      let total = 0;
      array.map((value) => (total += Number(value.prima_quincenal)));
      return total;
    },
    getTotalPorcentageBeneficiaries(array) {
      let total = 0;
      array.map((value) => (total += value.porcentaje));
      return total;
    },
    getTotalModulesCoverage(array) {
      let total = 0;
      array.map((value) => (total += Number(value.modulos)));
      return total;
    },
    getTotalModuleDependent(dependents) {
      dependents.map(
        (dependents) => {
          dependents.additional_digital_sales_coverages.map((coverage) => {
            this.totalAmountDependents += Number(coverage.prima_quincenal);
            this.totalModulesDependents += coverage.modulos;
          });
        }
      );
    },
    change_to_inactive() {
      Swal.fire({
        title: '¿Estás seguro de querer dar de baja?',
        text: "No podrás revertirlo!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#E0E0E0',
        cancelButtonColor: '#dd6b33',
        confirmButtonText: 'Dar de baja',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          this.updateDigitalSale();
          this.isLoading = false;
        }
      })
    },
    change_to_active() {
      
      Swal.fire({
        title: '¿Estás seguro de aceptar la venta?',
        text: "No podrás revertirlo!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#E0E0E0',
        cancelButtonColor: '#dd6b33',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          this.create_personal_accident_from_digital_sale();
          this.isLoading = false;
        }
      })
    },
    swal_fire(icon, title, message){
      Swal.fire({
        icon: icon,
        title: title,
        text: message,
      });
    }
  }

}
</script>